module.exports = __webpack_public_path__ + "img/down-arrow.f3bc3f05.svg";